import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Import layout
import AppLayout from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ToastProvider } from './components/Toast';
import { PageTitleProvider } from './components/PageTitleContext';

// Import pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Lifetrees from './pages/Lifetrees';
import LifetreeDetail from './pages/LifetreeDetail';
import NodeDetail from './pages/NodeDetail';
import CharacterDetail from './pages/CharacterDetail';
import CharacterStateDetail from './pages/CharacterStateDetail';

function App() {
  return (
    <ToastProvider>
      <PageTitleProvider>
        <Router>
          <Routes>
            {/* Login route - không cần authentication */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes - cần authentication */}
            <Route path="/" element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="settings" element={<Settings />} />
              <Route path="lifetrees" element={<Lifetrees />} />
              <Route path="lifetrees/:id" element={<LifetreeDetail />} />
              <Route path="lifetrees/:lifeTreeId/nodes/:nodeId" element={<NodeDetail />} />
              <Route path="lifetrees/:lifeTreeId/characters/:characterId" element={<CharacterDetail />} />
              <Route path="lifetrees/:lifeTreeId/characters/:characterId/states/:stateId" element={<CharacterStateDetail />} />
            </Route>
            
            {/* Catch all route - redirect to dashboard */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </PageTitleProvider>
    </ToastProvider>
  );
}

export default App;
